import Tooltip from '../../../ui/Tooltip';
import IconInfo from '../../icon/IconInfo';
import React from 'react';

export default function TicketSectionTooltip() {
  return (
    <Tooltip content="This section is visible only for paid events"
      label="ticketTip" className="pl-0.5">
      <IconInfo className="text-gray-dark "/>
    </Tooltip>
  );
}
